export const Audit = {
    IbConfigSuperiorIb: '上級IB',
    IbConfigIbRole: 'IB角色',
    IbConfigResultRemark: '詳情',
    IbConfigApplicant: '申請人',
    IbConfigProcessTime: '處理時間',
    IbConfigSystemRemark: '系統提示內容',
    IbConfigStatusProcessing: '處理中',
    IbConfigStatusDone: '處理完成',
    IbConfigStatusFailed: '處理失敗',
    IbConfigStatusRejected: '審核拒絕',
    IbConfigStatusPendingAudit: '等待送審',
    IbConfigStatusAuditing: '審批中',
    IbConfigStatusPending: '待執行',
    IbConfigOperatorName: '工單提交人',
    IbConfigSubmitSource: '提交來源',
    IbConfigSubmitterSelf: '本銷售',
    IbConfigSubmitterSubordinate: '下級銷售',
    IbConfigAccountUuid: '客戶UUID',
    IbConfigSuperiorIbUuid: '上級IB UUID',
    // [meegle:14347943] 工單列表 Tab / 帳戶列 / IB UUID 查詢項
    IbConfigTabUpgrade: '升級IB',
    IbConfigTabRebate: 'IB返佣配置',
    IbConfigClientAccount: '客戶帳戶',
    IbConfigIbAccount: 'IB帳戶',
    IbConfigIbUuid: 'IB UUID',
    // [越權治理] 詳情頁連結無效 / 非本人連結時的空態
    IbConfigTicketUnavailable: '工單不存在或無權查看',
    IbConfigBackToList: '返回工單列表',
    IbConfigSourceAdmin: 'BSS Admin端',
    IbConfigSourceSales: 'BSS 銷售端',
    IbConfigBizRebate: 'IB返佣配置',
    IbConfigBizUpgrade: 'IB升級',
    IbConfigCurrentInfo: '當前資訊',
    IbConfigLinkTitle: '開戶權限連結',
    IbConfigLinkSummary: '共 {total} 條，新增 {added} 條',
    IbConfigLinkName: '連結名稱',
    IbConfigLinkSource: '來源',
    IbConfigLinkDefault: '預設',
    IbConfigLinkNew: '新增',
    IbConfigLinkExisting: '現有',
    IbConfigRebateTitle: '返佣策略明細',
    IbConfigRebateCount: '共 {count} 項',
    IbConfigRebateAccountType: '帳戶類型',
    IbConfigRebateSubType: '子類型',
    IbConfigRebateColValue: '數值 / 外匯數值',
    IbConfigRebateColMetal: '貴金屬數值',
    IbConfigSymbolRuleTitle: '品種組返佣規則',
    IbConfigSymbolRuleCount: '{count} 條規則',
    IbConfigSymbolRuleEmpty: '暫無品種組規則',
    IbConfigStatsTitle: '配置統計',
    IbConfigStatsLinkTotal: '連結總數',
    IbConfigStatsLinkNew: '新增連結',
    IbConfigStatsActiveSubType: '生效子類型',
    IbConfigSummaryTitle: '申請概要',
    IbConfigTicketTypeLabel: '工單類型',
    IbConfigTicketTypeUpgradeSub: '升級普通IB',
    IbConfigTicketTypeUpgradeTop: '升級頂級IB',
    IbConfigTicketTypeModifyStrategy: '返佣配置',
    IbConfigTopGroup: '頂級組組別',
    IbConfigRebateDesc: '子類型集合由全部連結去重生成。MT4 的 STP / ECN 與 MT5 的 ECN 為單一數值，貴金屬列不適用。',
    IbConfigSymbolRuleDesc: '提交時生成的最細粒度規則。',
    IbConfigSubmitterRequired: '請選擇您要查詢的下級銷售',
    IbConfigClientId: '客戶ID',
};
